/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeResourceGroupsQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  id: Types.Scalars['UUID']['input'];
  sessionsStartDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  sessionsEndDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type ClientEmployeeResourceGroupsQuery = { __typename: 'Query', clientEmployee?: { __typename: 'ClientEmployeeType', sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', edges: Array<{ __typename: 'ClientEmployeeSessionTypeEdge', node?: { __typename: 'ClientEmployeeSessionType', id: string, updatedAt: string, application?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, isSaas: boolean, productName?: string | null, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', category?: { __typename: 'ResourceCategoryType', id: string, parent?: { __typename: 'ResourceCategoryType', id: string } | null } | null } } } | null } | null } | null> } | null } | null };

export type ClientEmployeeApplicationFragment = { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, vendorName?: string | null, productName?: string | null, productDomainName?: string | null, productDescription?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalSessions: number } } | null };

export type ClientEmployeeAppUsageQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  id: Types.Scalars['UUID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  applicationsOrderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sessionsStartDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  sessionsEndDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type ClientEmployeeAppUsageQuery = { __typename: 'Query', clientEmployee?: { __typename: 'ClientEmployeeType', applications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, vendorName?: string | null, productName?: string | null, productDomainName?: string | null, productDescription?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalSessions: number } } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };


export const ClientEmployeeApplicationFragmentDoc = `
    fragment ClientEmployeeApplication on ClientApplicationType {
  id
  resource {
    id
    vendorName
    productName
    productDomainName
    productDescription
    publicResource {
      category {
        id
        name
        parent {
          id
          name
        }
      }
      signedLogoUrl
    }
  }
  resourceGroupApplications {
    stats {
      totalSessions
    }
  }
}
    `;
export const ClientEmployeeResourceGroupsDocument = `
    query ClientEmployeeResourceGroups($clientId: UUID!, $id: UUID!, $sessionsStartDate: DateTime, $sessionsEndDate: DateTime) {
  clientEmployee(clientId: $clientId, id: $id) {
    sessions(
      first: 100
      updatedAt_Gte: $sessionsStartDate
      updatedAt_Lte: $sessionsEndDate
    ) {
      edges {
        node {
          id
          application {
            id
            resource {
              id
              isSaas
              resourceGroup {
                id
              }
              productName
              publicResource {
                category {
                  id
                  parent {
                    id
                  }
                }
              }
            }
          }
          updatedAt
        }
      }
    }
  }
}
    `;

export const useClientEmployeeResourceGroupsQuery = <
      TData = ClientEmployeeResourceGroupsQuery,
      TError = unknown
    >(
      variables: ClientEmployeeResourceGroupsQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeResourceGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeResourceGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeResourceGroupsQuery, TError, TData>(
      {
    queryKey: ['ClientEmployeeResourceGroups', variables],
    queryFn: fetcher<ClientEmployeeResourceGroupsQuery, ClientEmployeeResourceGroupsQueryVariables>(ClientEmployeeResourceGroupsDocument, variables),
    ...options
  }
    )};

useClientEmployeeResourceGroupsQuery.getKey = (variables: ClientEmployeeResourceGroupsQueryVariables) => ['ClientEmployeeResourceGroups', variables];

export const useInfiniteClientEmployeeResourceGroupsQuery = <
      TData = InfiniteData<ClientEmployeeResourceGroupsQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeResourceGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeResourceGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeResourceGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeResourceGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployeeResourceGroups.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeResourceGroupsQuery, ClientEmployeeResourceGroupsQueryVariables>(ClientEmployeeResourceGroupsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeResourceGroupsQuery.getKey = (variables: ClientEmployeeResourceGroupsQueryVariables) => ['ClientEmployeeResourceGroups.infinite', variables];


useClientEmployeeResourceGroupsQuery.fetcher = (variables: ClientEmployeeResourceGroupsQueryVariables) => fetcher<ClientEmployeeResourceGroupsQuery, ClientEmployeeResourceGroupsQueryVariables>(ClientEmployeeResourceGroupsDocument, variables);

export const ClientEmployeeAppUsageDocument = `
    query ClientEmployeeAppUsage($clientId: UUID!, $id: UUID!, $first: Int, $offset: Int, $applicationsOrderBy: String, $sessionsStartDate: DateTime, $sessionsEndDate: DateTime, $parentCategoryId: UUID) {
  clientEmployee(clientId: $clientId, id: $id) {
    applications(
      first: $first
      offset: $offset
      orderBy: $applicationsOrderBy
      employees_Id: $id
      sessionsStartDate: $sessionsStartDate
      sessionsEndDate: $sessionsEndDate
      parentCategoryId: $parentCategoryId
      resource_IsPrimaryResource: true
    ) {
      edges {
        node {
          ...ClientEmployeeApplication
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientEmployeeApplicationFragmentDoc}`;

export const useClientEmployeeAppUsageQuery = <
      TData = ClientEmployeeAppUsageQuery,
      TError = unknown
    >(
      variables: ClientEmployeeAppUsageQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeAppUsageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeAppUsageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeAppUsageQuery, TError, TData>(
      {
    queryKey: ['ClientEmployeeAppUsage', variables],
    queryFn: fetcher<ClientEmployeeAppUsageQuery, ClientEmployeeAppUsageQueryVariables>(ClientEmployeeAppUsageDocument, variables),
    ...options
  }
    )};

useClientEmployeeAppUsageQuery.getKey = (variables: ClientEmployeeAppUsageQueryVariables) => ['ClientEmployeeAppUsage', variables];

export const useInfiniteClientEmployeeAppUsageQuery = <
      TData = InfiniteData<ClientEmployeeAppUsageQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeAppUsageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeAppUsageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeAppUsageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeAppUsageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployeeAppUsage.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeAppUsageQuery, ClientEmployeeAppUsageQueryVariables>(ClientEmployeeAppUsageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeAppUsageQuery.getKey = (variables: ClientEmployeeAppUsageQueryVariables) => ['ClientEmployeeAppUsage.infinite', variables];


useClientEmployeeAppUsageQuery.fetcher = (variables: ClientEmployeeAppUsageQueryVariables) => fetcher<ClientEmployeeAppUsageQuery, ClientEmployeeAppUsageQueryVariables>(ClientEmployeeAppUsageDocument, variables);
